import { PrototypeApiError } from "../apiClient";

export function isOptionalIntegrationError(error: unknown) {
  // 429 is intentionally excluded: a rate-limit on the core auth flow
  // (too_many_attempts / rate_limited) is a legitimate user-facing lockout,
  // not evidence that an optional integration is missing. Including it here
  // shadowed the correct "Too many sign-in attempts" message in
  // describeAuthError().
  return error instanceof PrototypeApiError && (error.status === 404 || error.status === 503);
}
